import './index.scss';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React from 'react';
import CommentsPanel from '~/components/comments_panel';
import { useWorkspaceFolder } from '../../provider';
import ComparisonGrid from './comparison_grid';
import { ActionControls } from './comparison_grid/actions';
import { useComparisonGrid, } from './comparison_grid/provider';
const ComparisonsTab = () => {
    var _a;
    const { activeFolderId, comparisonDetails, isLoadingComparisonDetail, } = useWorkspaceFolder();
    const { gridData, selectedComparison, setSelectedComparison, showActionsControl, } = useComparisonGrid();
    const hasNoComparisons = activeFolderId && (!comparisonDetails || comparisonDetails.length === 0);
    if (activeFolderId && comparisonDetails) {
        return (React.createElement(React.Fragment, null,
            showActionsControl &&
                React.createElement(ActionControls, null),
            React.createElement("h4", { className: 'comparison-count' },
                "Comparisons (", (_a = gridData === null || gridData === void 0 ? void 0 : gridData.length) !== null && _a !== void 0 ? _a : 0,
                ")"),
            React.createElement("div", { className: "project-workspace-comparison-grid" },
                React.createElement(ComparisonGrid, null)),
            selectedComparison &&
                React.createElement(CommentsPanel, { comparisonDetail: selectedComparison, onHide: () => setSelectedComparison(null) })));
    }
    return (React.createElement(React.Fragment, null,
        !isLoadingComparisonDetail && React.createElement("h4", { className: 'comparison-count' }, "Comparisons (0)"),
        React.createElement("div", { className: 'empty-folder-container' },
            React.createElement(React.Fragment, null,
                isLoadingComparisonDetail &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: 'loading-data-icon' },
                            React.createElement(LoadingElement, { isLightBackground: true }))),
                !isLoadingComparisonDetail &&
                    React.createElement(React.Fragment, null,
                        React.createElement("img", { src: '/icons/SVG_Empty_File.svg', alt: 'Empty file' }),
                        React.createElement("div", { className: 'empty-folder-heading' }, hasNoComparisons
                            ? 'This folder doesn’t contain any comparisons'
                            : 'No folder is selected'),
                        React.createElement("div", { className: 'empty-folder-sub-heading' }, hasNoComparisons
                            ? 'Add comparisons from the comparison grid view using the action menu'
                            : 'Please select a folder'))))));
};
export default ComparisonsTab;
